var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.scaleTemplate,{tag:"component",attrs:{"data":_vm.row.scale,"scale-name":_vm.row.scale_type,"scale-config":_vm.scaleEditConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }